export const DOCUMENT_DATE_FALLBACK = 'Unknown date';

const SHORT_DATE_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};

const LONG_DATE_OPTIONS = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};

const toValidDate = (dateValue) => {
    if (!dateValue) return null;

    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    return Number.isNaN(date.getTime()) ? null : date;
};

const formatDocumentDate = (dateValue, options, fallback = DOCUMENT_DATE_FALLBACK) => {
    const date = toValidDate(dateValue);
    if (!date) return fallback;

    return date.toLocaleDateString('en-US', options);
};

export const formatDocumentCardDate = (dateValue) => (
    formatDocumentDate(dateValue, SHORT_DATE_OPTIONS)
);

export const formatDocumentListDate = (dateValue) => (
    formatDocumentDate(dateValue, LONG_DATE_OPTIONS)
);

export const formatDocumentPreviewDate = (dateValue) => {
    const date = toValidDate(dateValue);
    return date ? date.toLocaleDateString() : '';
};
